<template>
  <router-view/>
</template>

<style lang="scss">
html, body {
  background-color: var(--blackest-black);
  font-family: "OCR-A";
}

#app {
  text-align: center;
  color: #2c3e50;
}

:root {
  --cyber-yellow: #ffff00;
  --blackest-black: #000000;
  --whitest-white: #ffffff;
}
</style>
